export default {
  name: 'lifeEventTheme',
  isPublishable: true,
  uniqKey: '_id',
  crudMapping: {
    create: 'createLifeEventTheme',
    readMany: 'lifeEventThemes',
    readOne: 'lifeEventTheme',
    update: 'updateLifeEventTheme',
    // delete: 'deleteLifeEventTheme',
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === 'published') {
        return value ? 'Yes' : 'No';
      }
      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
        },
        published: {
          type: 'boolean',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Life Event Theme',
      type: 'object',
      required: ['title', 'image', 'lifeEventCategoryIds'],
      properties: {
        published: {
          type: 'boolean',
          default: true,
        },
        title: {
          type: 'string',
        },
        description: {
          type: 'string',
          description: 'Enter the description for this life event theme. This field has a 280 character limit.',
          maxLength: 280,
        },
        image: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
          default: 1000,
        },
        lifeEventCategoryIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
        },
        companyIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
          title: 'Associated companies',
        },
        hidden: {
          type: 'boolean',
          default: false,
          title: 'Hide from frontend',
        },
      },
    },
    uiSchema: {
      published: {
        'ui:widget': 'hidden',
      },
      lifeEventCategoryIds: {
        'ui:field': 'hasManyField',
        'ui:options': {
          sortable: true,
        },
      },
      companyIds: {
        'ui:field': 'hasManyField',
      },
      image: {
        'ui:widget': 'imageWidget',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/lifeEventTheme.js